import styled from 'styled-components'
import { MEDIA } from 'utils/constants'

const { MOBILE_UP, MOBILE } = MEDIA

export const StepsContainer = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  background-color: var(--the-white);
  z-index: 3;
  margin: 0;
  left: 0;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  position: sticky;
  top: 58px;
  width: 100%;

  @media screen and ${MOBILE_UP} {
    top: 86px;
;
d ${MOBILE} {
    padding: 0 2rem;
    position: initial;
  }
`

export const StepsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  width: 100%;
  padding: 15px 0;
  @media screen and ${MOBILE} {
    padding: 0;
    align-items: baseline;
  }
`

export const StepBall = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 64px;
  width: 100px;
  height: 4px;

  font-family: var(--font-family);
  color: var(--the-white);

  ${({ active }) => active
    ? 'background-color: var(--cobasi-blue-light-9);'
    : 'background-color: var(--light-gray);'
  };

  @media screen and ${MOBILE} {
   width: 100%;
  }
`

export const Step = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
  flex: 0 1 60px;

  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;

  background-color: var(--the-white);

  &:nth-child(2) {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }

  @media screen and ${MOBILE} {
    flex-direction: column;
    text-align: center;
    z-index: 4;
    background-color: transparent;
    position: relative;

    font-size: 1.2rem;
    font-weight: 400;
  }
`
